const { SYSLOG_SEVERITY_LEVEL, SYSLOG_FACILITY, ULS_EVENT_TYPE } = require('./constants');
const Logger = require('./logger');

module.exports = { Logger, SYSLOG_SEVERITY_LEVEL, SYSLOG_FACILITY, ULS_EVENT_TYPE };
